// extracted by mini-css-extract-plugin
export default {"container":"RedeemView_container__v4PqD","btnContainer":"RedeemView_btnContainer__nv7Y3","btn":"RedeemView_btn__qDZc-","btnCancel":"RedeemView_btnCancel__hQW6a"};